import { Tooltip } from 'react-tooltip';
import { getTooltipUniqueId } from '@/services/UtilsService';
import { InfoIcon } from '@/components/icons';
import { ReactNode } from 'react';

export function HelpTooltip({ children }: { children: ReactNode }) {
  const id = getTooltipUniqueId('HelpTooltip');
  return (
    <div data-tooltip-id={id}>
      <InfoIcon className="w-4 h-4" />
      <Tooltip id={id} className="tooltip text-sm">
        {children}
      </Tooltip>
    </div>
  );
}
